const firebaseConfig = {
apiKey: "AIzaSyC1EPDnLcxa0A0am1kQUilBu1VDGRVlzkM",
authDomain: "blocpod-39df1.firebaseapp.com",
projectId: "blocpod-39df1",
storageBucket: "blocpod-39df1.appspot.com",
messagingSenderId: "828766911528",
appId: "1:828766911528:web:177c0146ff2fe2a5a7891d"
  };

  export default firebaseConfig;